import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from '@angular/material/dialog';

@Component({
  selector: 'app-custom-action-component',
  templateUrl: './custom-action-component.component.html',
  styleUrls: ['./custom-action-component.component.scss'],
})
export class CustomActionComponentComponent implements OnInit {
  selectedCustomComponent = null;

  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<CustomActionComponentComponent>
  ) {}

  ngOnInit(): void {
    this.selectedCustomComponent = this.data?.actionComponentId;
  }

  customComponentOutput(event): any {
    if (event[0]?.from === 'resultData') {
      this.dialogRef?.close(event[0]?.data);
    }
  }
}
